export type PricingPlanId = `Essential` | `Business` | `Platform` | `Enterprise`

export interface PricingPlan {
  id: PricingPlanId
  title: string
  highlighted: boolean
  enterprise: boolean
}

export const PRICING_PLANS: PricingPlan[] = [
  {
    id: `Essential`,
    title: `Essentials`,
    highlighted: false,
    enterprise: false,
  },
  { id: `Business`, title: `Business`, highlighted: true, enterprise: false },
  { id: `Platform`, title: `Platform`, highlighted: false, enterprise: false },
]

export const ENTERPRISE_PLAN: PricingPlan = {
  id: `Enterprise`,
  title: `Enterprise`,
  highlighted: false,
  enterprise: true,
}

export const ALL_PRICING_PLANS = [...PRICING_PLANS, ENTERPRISE_PLAN]
